export const mainProsecutorOrganizationDistrictId = '1000000000000001';
